import React from 'react';
import Support from '../../shared/Support';

export default function UserLockout() {
  return (
    <div className="text-center" id="content">
      <h1 className="font-avenir-medium text-navy-blue text-2xl">Account Locked Out</h1>
      <p>
        Due to too many failed login attempts, we've blocked access to your account. Please contact
        Credit Key support to unlock your account.
      </p>

      <Support />
    </div>
  );
}
